import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSparkleCentral: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSparkleCentral"><Path d="M12.6562 2.5L15.0332 8.67969L15.1133 8.88672L15.3203 8.9668L21.5 11.3428V12.6562L15.3203 15.0332L15.1133 15.1133L15.0332 15.3203L12.6562 21.5H11.3438L8.9668 15.3203L8.88672 15.1133L8.67969 15.0332L2.5 12.6562V11.3428L8.67969 8.9668L8.88672 8.88672L8.9668 8.67969L11.3438 2.5H12.6562Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconSparkleCentral;
